import React, { useState, useEffect, useCallback, useMemo } from 'react';
import NumericKeypad from '../Conf/NumericKeyPad';
import RentDressDialog from './RentDressDialog';
import RentSuitDialog from './RentSuitDialog'
import Divider from '@mui/material/Divider';
import ServiceCard from './ServiceCard';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Slider from "react-slick"; // Sigue siendo necesario para DesktopView
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import EditIcon from '@mui/icons-material/Edit';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { Tree } from 'antd';
import Bill from '../../../assets/pictures/bill.png';
import BillBlack from '../../../assets/pictures/bill_black.png';
import '../../../Styles/Interface/Services/AdditionalServices.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useMediaQuery, Paper, Fab, Box, Typography, Grid, Tabs, Tab, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText } from '@mui/material'; // Añadido Tabs, Tab
import { useTheme } from '@mui/material/styles';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const { TreeNode } = Tree;

// --- Constants ---
const MAX_DISCOUNT_PERCENT = 35;
const DEFAULT_DEPOSIT = 2000;
const DRESS_SERVICE_TYPE = 'Vestidos';
const SUIT_SERVICE_TYPE = 'Trajes';
const XV_DRESS_SERVICE_ID = 12;
const WEDDING_DRESS_SERVICE_ID = 22;
const PERSONAL_DRESS_SERVICE_ID = 13;
const CHILD_DRESS_SERVICE_ID = 14;
const SUIT_SERVICE_ID = 35;
const CHILD_SUIT_SERVICE_ID = 36;
const XV_DRESS_TYPE = 'xv';
const WEDDING_DRESS_TYPE = 'wedding';
const SUIT_TYPE = 'men';
const CHILD_SUIT_TYPE = 'child';
const PAYMENT_STATUS_PAID = 'pagado';
const PAYMENT_STATUS_PENDING = 'pendiente';
const EDITING_TYPE_SERVICE = 'service';
const EDITING_TYPE_DEPOSIT = 'deposit';
const EDITING_TYPE_NONE = 'none';
const EDITING_FIELD_QUANTITY = 'quantity';
const EDITING_FIELD_PRICE = 'servicePrice';
const EDITING_FIELD_DISCOUNT = 'discountApplied';
const EDITING_FIELD_PAID = 'amountPaid';
// ---

const safeParseFloat = (value, defaultValue = 0) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const parsed = parseFloat(value.replace(/,/g, ''));
    return isNaN(parsed) ? defaultValue : parsed;
  }
  return defaultValue;
};

const formatCurrency = (value) => {
  return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const calculateServiceTotals = (service) => {
  const isDressService = service.serviceType === DRESS_SERVICE_TYPE && Array.isArray(service.dresses);
  const quantity = isDressService ? service.dresses.length : (service.quantity || 0);
  const price = safeParseFloat(service.servicePrice);
  const discount = Math.min(service.discountApplied || 0, MAX_DISCOUNT_PERCENT);
  const priceWDisc = discount > 0 ? price * (1 - discount / 100) : price;
  const total = priceWDisc * quantity;
  const amountPaid = Math.min(service.amountPaid || 0, total);
  const paymentStatus = Math.abs(amountPaid - total) < 0.01 ? PAYMENT_STATUS_PAID : PAYMENT_STATUS_PENDING;

  return {
    ...service,
    quantity,
    servicePrice: price,
    discountApplied: discount,
    priceWDisc,
    amountPaid,
    totalPrice: total,
    paymentStatus,
  };
};

function AdditionalServicesRe({
  reservation,
  previousStepHandler,
  nextStepHandler,
  updateSelectedServices,
  selectedServices: initialSelectedServices,
  services: availableServices,
  arrOfServiceTypes,
  depositChangeHandler,
  dressList,
  suitList,
  additionalDress,
  additionalSuit,
  handleServicesInvoice,
  dressReservations,
  suitReservations,
  eventDate,
  deleteDressWithID,
  deleteSuitWithID,
  newDressReservation,
  newSuitReservation,
  event
}) {

  const [selectedAdditionalServices, setSelectedAdditionalServices] = useState([]);
  const [serviceTypeFilter, setServiceTypeFilter] = useState('Todos'); // Default filter to 'Todos'
  const [selectedServiceKey, setSelectedServiceKey] = useState(null);
  const [isFirstKey, setIsFirstKey] = useState(true);
  const [deposit, setDeposit] = useState(() => safeParseFloat(reservation?.deposit, 0));
  const [editingTarget, setEditingTarget] = useState({ type: EDITING_TYPE_SERVICE, field: EDITING_FIELD_QUANTITY });
  const [openXVDressDialog, setOpenXVDressDialog] = useState(false);
  const [openWDressDialog, setOpenWDressDialog] = useState(false);
  const [openPersonalDressDialog, setOpenPersonalDressDialog] = useState(false);
  const [openChildDressDialog, setOpenChildDressDialog] = useState(false);
  const [openSuitDialog, setOpenSuitDialog] = useState(false);
  const [openChildSuitDialog, setOpenChildSuitDialog] = useState(false);
  const [dressSelectionServiceInfo, setDressSelectionServiceInfo] = useState(null);
  const [suitSelectionServiceInfo, setSuitSelectionServiceInfo] = useState(null);
  const [isServiceSelectorOpen, setIsServiceSelectorOpen] = useState(false);
  const [editingDress, setEditingDress] = useState(null);
  const [editingSuit, setEditingSuit] = useState(null);

  const openServiceSelector = () => setIsServiceSelectorOpen(true);
  const closeServiceSelector = () => setIsServiceSelectorOpen(false);

  const handleMobileServiceSelected = (service) => {
    handleSelectServiceToAdd(service);
    closeServiceSelector();
  };

  // Prepare tab options for MUI Tabs
  const tabOptions = useMemo(() => ['Todos', ...(arrOfServiceTypes || []).filter(type => type !== 'Inventario')], [arrOfServiceTypes]);

  const handleTabChange = (event, newValue) => {
    handleServiceTypeFilterChange(newValue); // newValue is the string value of the Tab
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const reservationComboPrice = useMemo(() => safeParseFloat(reservation?.comboPrice, 0), [reservation?.comboPrice]);

  useEffect(() => {
    setSelectedAdditionalServices(initialSelectedServices.map(calculateServiceTotals));
    if (initialSelectedServices.length > 0) {
      setSelectedServiceKey(initialSelectedServices[0].serviceID ?? initialSelectedServices[0].serviceName);
      setEditingTarget({ type: EDITING_TYPE_SERVICE, field: EDITING_FIELD_QUANTITY });
    } else {
      setSelectedServiceKey(null);
      setEditingTarget({ type: EDITING_TYPE_NONE });
    }
  }, [initialSelectedServices]);

  const selectedService = useMemo(() => {
    if (!selectedServiceKey) return null;
    return selectedAdditionalServices.find(s => (s.serviceID ?? s.serviceName) === selectedServiceKey) || null;
  }, [selectedServiceKey, selectedAdditionalServices]);

  const filterAvailableDresses = useCallback((dresses, dressType) => {
    if (!dressReservations || !eventDate?.eventDateStart || !eventDate?.eventDateEnd) return dresses;
    const eventStart = new Date(eventDate.eventDateStart);
    const eventEnd = new Date(eventDate.eventDateEnd);
    return dresses.filter(dress => {
      if (dress.dressType !== dressType) return false;
      const dressInCurrentReservation = reservation?.longDressID === dress.dressID || reservation?.shortDressID === dress.dressID;
      if (dressInCurrentReservation) return false;
      const hasConflict = dressReservations.some(res => {
        if (res.dressID !== dress.dressID) return false;
        const resStart = new Date(res.eventDateStart);
        const resEnd = new Date(res.eventDateEnd);
        return (eventStart <= resEnd) && (eventEnd >= resStart);
      });
      return !hasConflict;
    });
  }, [dressReservations, eventDate, reservation?.longDressID, reservation?.shortDressID]);

  const filterAvailableSuits = useCallback((suits, suitType) => {
    if (!suitReservations || !eventDate?.eventDateStart || !eventDate?.eventDateEnd) return suits;
    const eventStart = new Date(eventDate.eventDateStart);
    const eventEnd = new Date(eventDate.eventDateEnd);
    return suits.filter(suit => {
      if (suit.suitType !== suitType) return false;
      // Aquí puedes añadir lógica para excluir trajes ya en la reserva principal si aplica
      const suitInCurrentReservation = reservation?.suitID === suit.suitID;
      if (suitInCurrentReservation) return false;
      const hasConflict = suitReservations.some(res => {
        if (res.suitID !== suit.suitID) return false; // Asumiendo que la reserva tiene suitID
        const resStart = new Date(res.eventDateStart);
        const resEnd = new Date(res.eventDateEnd);
        return (eventStart <= resEnd) && (eventEnd >= resStart);
      });
      return !hasConflict;
    });
  }, [suitReservations, eventDate, reservation]);

  const XVDressList = useMemo(() => filterAvailableDresses(dressList, XV_DRESS_TYPE), [dressList, filterAvailableDresses]);
  const WDressList = useMemo(() => filterAvailableDresses(dressList, WEDDING_DRESS_TYPE), [dressList, filterAvailableDresses]);
  const personalDressList = useMemo(() => filterAvailableDresses(dressList, 'personal'), [dressList, filterAvailableDresses]);
  const childDressList = useMemo(() => filterAvailableDresses(dressList, 'girls'), [dressList, filterAvailableDresses]);
  const menSuitList = useMemo(() => filterAvailableSuits(suitList, SUIT_TYPE), [suitList, filterAvailableSuits]);
  const childSuitList = useMemo(() => filterAvailableSuits(suitList, CHILD_SUIT_TYPE), [suitList, filterAvailableSuits]);

  const handleServiceTypeFilterChange = (type) => {
    setServiceTypeFilter(type);
  };

  const addOrIncrementService = useCallback((serviceToAdd) => {
    setSelectedAdditionalServices(prevServices => {
      const existingServiceIndex = prevServices.findIndex(s => (s.serviceID ?? s.serviceName) === (serviceToAdd.serviceID ?? serviceToAdd.serviceName));
      let updatedServices;
      if (existingServiceIndex > -1) {
        updatedServices = prevServices.map((s, index) =>
          index === existingServiceIndex ? calculateServiceTotals({ ...s, quantity: s.quantity + 1 }) : s
        );
      } else {
        const newService = calculateServiceTotals({ ...serviceToAdd, quantity: 1, discountApplied: 0, amountPaid: 0 });
        updatedServices = [...prevServices, newService];
      }
      setSelectedServiceKey(serviceToAdd.serviceID ?? serviceToAdd.serviceName);
      setEditingTarget({ type: EDITING_TYPE_SERVICE, field: EDITING_FIELD_QUANTITY });
      setIsFirstKey(true);
      return updatedServices;
    });
  }, []);

  const handleSelectServiceToAdd = useCallback((service) => {
    if (service.serviceType === DRESS_SERVICE_TYPE) {
      setDressSelectionServiceInfo(service);
      if (service.serviceID === XV_DRESS_SERVICE_ID) setOpenXVDressDialog(true);
      else if (service.serviceID === WEDDING_DRESS_SERVICE_ID) setOpenWDressDialog(true);
      else if (service.serviceID === PERSONAL_DRESS_SERVICE_ID) setOpenPersonalDressDialog(true);
      else if (service.serviceID === CHILD_DRESS_SERVICE_ID) setOpenChildDressDialog(true);
      return;
    } else if (service.serviceID === SUIT_SERVICE_ID || service.serviceID === CHILD_SUIT_SERVICE_ID) {
      setSuitSelectionServiceInfo(service);
      if (service.serviceID === SUIT_SERVICE_ID) setOpenSuitDialog(true);
      else if (service.serviceID === CHILD_SUIT_SERVICE_ID) setOpenChildSuitDialog(true);
      return;
    }
    addOrIncrementService(service);
  }, [addOrIncrementService]);

  const handleSelectExistingService = useCallback((serviceKey) => {
    setSelectedServiceKey(serviceKey);
    if (editingTarget.type !== EDITING_TYPE_DEPOSIT) {
      setEditingTarget({ type: EDITING_TYPE_SERVICE, field: EDITING_FIELD_QUANTITY });
    }
    setIsFirstKey(true);
  }, [editingTarget.type]);

  const deleteSelectedService = useCallback((serviceToDeleteKey) => {
    setSelectedAdditionalServices(prevServices => {
      const serviceToRemove = prevServices.find(s => (s.serviceID ?? s.serviceName) === serviceToDeleteKey);

      if (serviceToRemove) {
        // Lógica para vestidos
        if (serviceToRemove.serviceType === DRESS_SERVICE_TYPE && Array.isArray(serviceToRemove.dresses)) {
          serviceToRemove.dresses.forEach(dress => deleteDressWithID(dress.dressID));
        }
        // Lógica para trajes
        if ((serviceToRemove.serviceType === SUIT_SERVICE_TYPE || serviceToRemove.serviceType === CHILD_SUIT_SERVICE_ID) && Array.isArray(serviceToRemove.suits)) {
          serviceToRemove.suits.forEach(suit => deleteSuitWithID(suit.suitID));
        }
      }

      const updatedServices = prevServices.filter(s => (s.serviceID ?? s.serviceName) !== serviceToDeleteKey);
      if (selectedServiceKey === serviceToDeleteKey) {
        setSelectedServiceKey(updatedServices.length > 0 ? (updatedServices[0].serviceID ?? updatedServices[0].serviceName) : null);
      }
      return updatedServices;
    });
  }, [selectedServiceKey, deleteDressWithID, deleteSuitWithID]);

  const updateServiceValue = useCallback((key) => {
    if (!selectedService || editingTarget.type !== EDITING_TYPE_SERVICE || !editingTarget.field) return;
    if (editingTarget.field === EDITING_FIELD_QUANTITY && (selectedService.serviceType === DRESS_SERVICE_TYPE || selectedService.serviceType === 'Trajes')) return;
    setSelectedAdditionalServices(prevServices =>
      prevServices.map(s => {
        if ((s.serviceID ?? s.serviceName) !== selectedServiceKey) return s;
        let currentValue = s[editingTarget.field] || 0;
        let newValue = isFirstKey ? key : currentValue * 10 + key;
        if (editingTarget.field === EDITING_FIELD_PAID) {
          const price = s.priceWDisc > 0 ? s.priceWDisc : s.servicePrice;
          const maxAmount = price * s.quantity;
          newValue = Math.min(newValue, maxAmount);
        }
        if (editingTarget.field === EDITING_FIELD_DISCOUNT) newValue = Math.min(newValue, 100);
        return calculateServiceTotals({ ...s, [editingTarget.field]: newValue });
      })
    );
    setIsFirstKey(false);
  }, [selectedService, editingTarget, selectedServiceKey, isFirstKey]);

  const updateDepositValue = useCallback((key) => {
    if (editingTarget.type !== EDITING_TYPE_DEPOSIT) return;
    setDeposit(prev => {
      const newValue = isFirstKey ? key : prev * 10 + key;
      return newValue <= reservationComboPrice ? newValue : prev;
    });
    setIsFirstKey(false);
  }, [editingTarget, isFirstKey, reservationComboPrice]);

  const handleKeyClick = useCallback((key) => {
    if (editingTarget.type === EDITING_TYPE_SERVICE) updateServiceValue(key);
    else if (editingTarget.type === EDITING_TYPE_DEPOSIT) updateDepositValue(key);
  }, [editingTarget, updateServiceValue, updateDepositValue]);

  const handleBackspaceClick = useCallback(() => {
    setIsFirstKey(true);
    if (editingTarget.type === EDITING_TYPE_SERVICE && selectedService && editingTarget.field) {
      if (editingTarget.field === EDITING_FIELD_QUANTITY && (selectedService.serviceType === DRESS_SERVICE_TYPE || selectedService.serviceType === 'Trajes')) return;
      setSelectedAdditionalServices(prevServices =>
        prevServices.map(s => {
          if ((s.serviceID ?? s.serviceName) !== selectedServiceKey) return s;
          let currentValue = s[editingTarget.field] || 0;
          const newValue = Math.floor(currentValue / 10);
          return calculateServiceTotals({ ...s, [editingTarget.field]: newValue });
        })
      );
    } else if (editingTarget.type === EDITING_TYPE_DEPOSIT) {
      setDeposit(prev => Math.floor(prev / 10));
    }
  }, [editingTarget, selectedService, selectedServiceKey]);

  const handleClearClick = useCallback(() => {
    setIsFirstKey(true);
    if (editingTarget.type === EDITING_TYPE_SERVICE && selectedService && editingTarget.field) {
      if (editingTarget.field === EDITING_FIELD_QUANTITY && (selectedService.serviceType === DRESS_SERVICE_TYPE || selectedService.serviceType === 'Trajes')) return;
      setSelectedAdditionalServices(prevServices =>
        prevServices.map(s => {
          if ((s.serviceID ?? s.serviceName) !== selectedServiceKey) return s;
          let resetValue = 0;
          if (editingTarget.field === EDITING_FIELD_PRICE) {
            const originalService = availableServices.find(as => as.serviceID === s.serviceID);
            resetValue = originalService ? safeParseFloat(originalService.servicePrice) : 0;
          }
          return calculateServiceTotals({ ...s, [editingTarget.field]: resetValue });
        })
      );
    } else if (editingTarget.type === EDITING_TYPE_DEPOSIT) {
      setDeposit(DEFAULT_DEPOSIT);
    }
  }, [editingTarget, selectedService, selectedServiceKey, availableServices]);

  const setActiveEditingTarget = (type, field = null) => {
    if (type === EDITING_TYPE_SERVICE && !selectedService) return;
    setEditingTarget({ type, field });
    setIsFirstKey(true);
  };

  const toggleFullPayment = useCallback(() => {
    if (!selectedService) return;
    setSelectedAdditionalServices(prevServices =>
      prevServices.map(s => {
        if ((s.serviceID ?? s.serviceName) !== selectedServiceKey) return s;
        const isCurrentlyPaid = s.paymentStatus === PAYMENT_STATUS_PAID;
        const newAmountPaid = isCurrentlyPaid ? 0 : s.totalPrice;
        return calculateServiceTotals({ ...s, amountPaid: newAmountPaid });
      })
    );
    if (selectedService.paymentStatus !== PAYMENT_STATUS_PAID) {
      setActiveEditingTarget(EDITING_TYPE_SERVICE, EDITING_FIELD_QUANTITY);
    }
  }, [selectedService, selectedServiceKey]);

  // --- NUEVA LÓGICA PARA TRAJES (ANÁLOGA A LA DE VESTIDOS) ---
  const handleSuitSelectionLogic = useCallback((suit, serviceInfo) => {

    if (editingSuit) {
      // --- Lógica de Edición ---
      deleteSuitWithID(editingSuit.suitData.suitID);
      additionalSuit(suit);

      setSelectedAdditionalServices(prev => prev.map(s => {
        if (s.serviceID !== editingSuit.service.serviceID) return s;
        const updatedSuits = s.suits.map(d => d.suitID === editingSuit.suitData.suitID ? suit : d);
        // Usamos 'calculateServiceTotals', pero adaptado para un array 'suits'
        const quantity = updatedSuits.length;
        return calculateServiceTotals({ ...s, suits: updatedSuits, quantity });
      }));
      setEditingSuit(null);

    } else {
      // --- Lógica de Adición ---
      additionalSuit(suit);
      setSelectedAdditionalServices(prev => {
        const serviceIndex = prev.findIndex(s => s.serviceID === serviceInfo.serviceID);
        if (serviceIndex > -1) {
          return prev.map((s, index) => {
            if (index !== serviceIndex) return s;
            const updatedSuits = [...(s.suits || []), suit];
            const quantity = updatedSuits.length;
            return calculateServiceTotals({ ...s, suits: updatedSuits, quantity });
          });
        } else {
          const newService = {
            ...serviceInfo,
            suits: [suit] // Iniciar el array de trajes
          };
          return [...prev, calculateServiceTotals({ ...newService, quantity: 1 })];
        }
      });
    }
    setSelectedServiceKey(serviceInfo.serviceID);
  }, [editingSuit, additionalSuit, deleteSuitWithID]);

  const handleSelectedSuit = useCallback((suit) => {
    if (suit && suitSelectionServiceInfo) {
      handleSuitSelectionLogic(suit, suitSelectionServiceInfo);
    }
    setOpenSuitDialog(false);
    setSuitSelectionServiceInfo(null);
  }, [suitSelectionServiceInfo, handleSuitSelectionLogic]);

  const handleSelectedChildSuit = useCallback((suit) => {
    if (suit && suitSelectionServiceInfo) {
      handleSuitSelectionLogic(suit, suitSelectionServiceInfo);
    }
    setOpenChildSuitDialog(false);
    setSuitSelectionServiceInfo(null);
  }, [suitSelectionServiceInfo, handleSuitSelectionLogic]);

  const handleDeleteSuit = useCallback((service, suitToDelete) => {
    deleteSuitWithID(suitToDelete.suitID);

    setSelectedAdditionalServices(prev => {
      const serviceIndex = prev.findIndex(s => s.serviceID === service.serviceID);
      if (serviceIndex === -1) return prev;

      const serviceToUpdate = { ...prev[serviceIndex] };
      serviceToUpdate.suits = serviceToUpdate.suits.filter(d => d.suitID !== suitToDelete.suitID);

      if (serviceToUpdate.suits.length === 0) {
        return prev.filter(s => s.serviceID !== service.serviceID);
      } else {
        const updatedService = calculateServiceTotals({ ...serviceToUpdate, quantity: serviceToUpdate.suits.length });
        const updatedServices = [...prev];
        updatedServices[serviceIndex] = updatedService;
        return updatedServices;
      }
    });
  }, [deleteSuitWithID]);

  const handleEditSuit = useCallback((service, suitData) => {
    setEditingSuit({ service, suitData });
    setSuitSelectionServiceInfo(service); // Reutilizamos el estado
    setOpenSuitDialog(true);
  }, []);

  // Lógica central para añadir o editar un vestido ---
  const handleDressSelectionLogic = useCallback((dress, serviceInfo) => {
    if (editingDress) {
      // --- Lógica de Edición ---
      deleteDressWithID(editingDress.dressData.dressID);
      additionalDress(dress);

      setSelectedAdditionalServices(prev => prev.map(s => {
        if (s.serviceID !== editingDress.service.serviceID) return s;
        const updatedDresses = s.dresses.map(d => d.dressID === editingDress.dressData.dressID ? dress : d);
        return calculateServiceTotals({ ...s, dresses: updatedDresses });
      }));
      setEditingDress(null);

    } else {
      // --- Lógica de Adición ---
      additionalDress(dress);

      setSelectedAdditionalServices(prev => {
        const serviceIndex = prev.findIndex(s => s.serviceID === serviceInfo.serviceID);
        if (serviceIndex > -1) {
          // El servicio ya existe, añadir el vestido a su array
          return prev.map((s, index) => {
            if (index !== serviceIndex) return s;
            const updatedDresses = [...s.dresses, dress];
            return calculateServiceTotals({ ...s, dresses: updatedDresses });
          });
        } else {
          // Primera vez que se añade este tipo de servicio de vestido
          const newService = {
            ...serviceInfo,
            dresses: [dress] // Iniciar el array de vestidos
          };
          return [...prev, calculateServiceTotals(newService)];
        }
      });
    }
    setSelectedServiceKey(serviceInfo.serviceID);
  }, [editingDress, additionalDress, deleteDressWithID]);

  const handleSelectedXVDress = useCallback((dress) => {
    if (dress && dressSelectionServiceInfo) {
      handleDressSelectionLogic(dress, dressSelectionServiceInfo);
    }
    setOpenXVDressDialog(false);
    setDressSelectionServiceInfo(null);
  }, [dressSelectionServiceInfo, handleDressSelectionLogic]);

  const handleSelectedWDress = useCallback((dress) => {
    if (dress && dressSelectionServiceInfo) {
      handleDressSelectionLogic(dress, dressSelectionServiceInfo);
    }
    setOpenWDressDialog(false);
    setDressSelectionServiceInfo(null);
  }, [dressSelectionServiceInfo, handleDressSelectionLogic]);

  const handleSelectedPersonalDress = useCallback((dress) => {
    if (dress && dressSelectionServiceInfo) {
      handleDressSelectionLogic(dress, dressSelectionServiceInfo);
    }
    setOpenPersonalDressDialog(false);
    setDressSelectionServiceInfo(null);
  }, [dressSelectionServiceInfo, handleDressSelectionLogic]);

  const handleSelectedChildDress = useCallback((dress) => {
    if (dress && dressSelectionServiceInfo) {
      handleDressSelectionLogic(dress, dressSelectionServiceInfo);
    }
    setOpenChildDressDialog(false);
    setDressSelectionServiceInfo(null);
  }, [dressSelectionServiceInfo, handleDressSelectionLogic]);

  // --- NUEVA FUNCIÓN: Elimina un vestido individual ---
  const handleDeleteDress = useCallback((service, dressToDelete) => {
    deleteDressWithID(dressToDelete.dressID); // Notificar al controlador

    setSelectedAdditionalServices(prev => {
      const serviceIndex = prev.findIndex(s => s.serviceID === service.serviceID);
      if (serviceIndex === -1) return prev;

      const serviceToUpdate = { ...prev[serviceIndex] };
      serviceToUpdate.dresses = serviceToUpdate.dresses.filter(d => d.dressID !== dressToDelete.dressID);

      if (serviceToUpdate.dresses.length === 0) {
        // Si no quedan vestidos, eliminar el servicio completo
        return prev.filter(s => s.serviceID !== service.serviceID);
      } else {
        // Si quedan, recalcular y actualizar
        const updatedService = calculateServiceTotals(serviceToUpdate);
        const updatedServices = [...prev];
        updatedServices[serviceIndex] = updatedService;
        return updatedServices;
      }
    });
  }, [deleteDressWithID]);

  // --- NUEVA FUNCIÓN: Inicia la edición de un vestido ---
  const handleEditDress = useCallback((service, dressData) => {
    setEditingDress({ service, dressData });
    setDressSelectionServiceInfo(service);
    if (service.serviceID === XV_DRESS_SERVICE_ID) setOpenXVDressDialog(true);
    else if (service.serviceID === WEDDING_DRESS_SERVICE_ID) setOpenWDressDialog(true);
    else if (service.serviceID === PERSONAL_DRESS_SERVICE_ID) setOpenPersonalDressDialog(true);
    else if (service.serviceID === CHILD_DRESS_SERVICE_ID) setOpenChildDressDialog(true);
  }, []);

  const handleProceedToCheckout = (e) => {
    updateSelectedServices(selectedAdditionalServices);
    console.log('Depósito:', deposit);

    depositChangeHandler(deposit);
    handleServicesInvoice(selectedAdditionalServices);
    nextStepHandler(e);
  };

  const calculateGrandTotal = useMemo(() => {
    const servicesTotal = selectedAdditionalServices.reduce((sum, service) => sum + service.totalPrice, 0);
    const reservationTotal = reservationComboPrice * ((100 - reservation.discount) / 100);
    return servicesTotal + reservationTotal;
  }, [selectedAdditionalServices, reservationComboPrice]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      const key = event.key;
      if (key >= '0' && key <= '9') handleKeyClick(Number(key));
      else if (key === 'Backspace') handleBackspaceClick();
      else if (key.toLowerCase() === 'c') handleClearClick();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyClick, handleBackspaceClick, handleClearClick, editingTarget.type, editingTarget.field]);

  const NextArrow = (props) => (<div {...props} style={{ ...props.style, display: 'block' }} ><ArrowForwardIosIcon style={{ color: '#f759ab' }} /></div>);
  const PrevArrow = (props) => (<div {...props} style={{ ...props.style, display: 'block' }}><ArrowBackIosIcon style={{ color: '#f759ab' }} /></div>);

  // Slider settings for Desktop view
  const desktopSliderSettings = {
    dots: true, infinite: false, speed: 500, slidesToShow: 4, initialSlide: 0, nextArrow: <NextArrow />, prevArrow: <PrevArrow />,
    responsive: [{ breakpoint: 1024, settings: { slidesToShow: 3 } }, { breakpoint: 600, settings: { slidesToShow: 2 } }, { breakpoint: 480, settings: { slidesToShow: 1 } }]
  };

  const isSelectedServicePaid = selectedService?.paymentStatus === PAYMENT_STATUS_PAID;
  const isSelectedServicePartiallyPaid = (selectedService?.amountPaid ?? 0) > 0 && selectedService?.paymentStatus !== PAYMENT_STATUS_PAID;

  const MobileView = () => {

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100dvh - 84px)', position: 'relative', overflow: 'hidden' }}>
        <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 1, paddingBottom: '80px' }}>
          <Paper elevation={2} sx={{ mb: 1 }}>
            <Box sx={{ p: 1, backgroundColor: 'aliceblue', textAlign: 'center' }}>
              <Typography variant="h5" sx={{ color: '#f759ab', fontWeight: 'bold' }}>Resumen de Servicios</Typography>
            </Box>
            <Box sx={{ maxHeight: '25vh', minHeight: '20vh', overflowY: 'auto' }}>
              {/* Servicio Principal (Reserva) */}
              {reservation && Object.keys(reservation).length > 0 && (
                <Box onClick={() => setActiveEditingTarget(EDITING_TYPE_DEPOSIT)} sx={{ p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', backgroundColor: editingTarget.type === EDITING_TYPE_DEPOSIT ? '#e6f7ff' : 'transparent', borderBottom: '1px solid #eee' }}>
                  <Box><Typography variant="subtitle2" component="div" fontWeight="bold">{reservation.comboName}</Typography><Typography variant="caption">1 × RD$ {formatCurrency(reservationComboPrice)}</Typography></Box>
                  <Box textAlign="right"><Typography variant="subtitle2" fontWeight="bold">RD$ {formatCurrency(reservationComboPrice)}</Typography><Typography variant="caption">(RD$ {formatCurrency(deposit)} pagados)</Typography></Box>
                </Box>
              )}
              {/* Servicios Adicionales */}
              {selectedAdditionalServices.map((service) => {
                const serviceKey = service.serviceID ?? service.serviceName;
                const isSelected = selectedServiceKey === serviceKey;
                {/* Vestidos */ }
                if (service.serviceType === DRESS_SERVICE_TYPE || service.serviceType === SUIT_SERVICE_TYPE || service.serviceType === CHILD_SUIT_TYPE) {
                  const isDress = service.serviceType === DRESS_SERVICE_TYPE;
                  const items = isDress ? service.dresses : service.suits;
                  const itemType = isDress ? (service.quantity > 1 ? 'vestidos' : 'vestido') : (service.quantity > 1 ? 'trajes' : 'traje');
                  const handleEdit = isDress ? handleEditDress : handleEditSuit;
                  const handleDelete = isDress ? handleDeleteDress : handleDeleteSuit;

                  return (
                    <Accordion key={serviceKey} disableGutters elevation={0} sx={{ backgroundColor: isSelected ? '#e6f2f3' : 'transparent', borderLeft: isSelected ? '5px solid #f759ab' : 'none', '&:before': { display: 'none' } }} onClick={() => handleSelectExistingService(serviceKey)}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ p: 1, minHeight: 'auto', '& .MuiAccordionSummary-content': { m: 0, justifyContent: 'space-between', alignItems: 'center' } }}>
                        <Box sx={{ flex: 3 }}>
                          <Typography variant="subtitle2" component="div" fontWeight="bold" noWrap>{service.serviceName}</Typography>
                          <Typography variant="caption">{service.quantity} {service.quantity > 1 ? 'vestidos' : 'vestido'}</Typography>
                          <br />
                          <Typography variant="caption">RD$ {formatCurrency(service.priceWDisc)}{service.discountApplied > 0 && ` (Desc. ${service.discountApplied}%)`}</Typography>
                        </Box>
                        <Box textAlign="right" sx={{ flex: 2 }}>
                          <Typography variant="subtitle2" fontWeight="bold">RD$ {formatCurrency(service.totalPrice)}</Typography>
                          <Typography variant="caption" color={service.paymentStatus === PAYMENT_STATUS_PAID ? 'green' : 'orange'}>(RD$ {formatCurrency(service.amountPaid)} pagados)</Typography>
                        </Box>
                        <IconButton size="small" sx={{ ml: 0.5, p: 0.5 }} onClick={(e) => { e.stopPropagation(); deleteSelectedService(serviceKey); }}>
                          <DeleteOutlineIcon fontSize="small" sx={{ color: 'red' }} />
                        </IconButton>
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, backgroundColor: '#fafafa' }}>
                        <List dense disablePadding>
                          {items.map(itemData => (
                            <ListItem
                              key={isDress ? itemData.dressID : itemData.suitID}
                              divider
                              secondaryAction={
                                <>
                                  <Tooltip title={isDress ? "Cambiar vestido" : "Cambiar traje"}>
                                    <span>
                                      <IconButton size="small" sx={{ mr: 0.5 }} onClick={(e) => { e.stopPropagation(); handleEdit(service, itemData); }}>
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                  <Tooltip title={isDress ? "Quitar vestido" : "Quitar traje"}>
                                    <span>
                                      <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleDelete(service, itemData); }}>
                                        <DeleteOutlineIcon fontSize="small" color="error" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                </>
                              }
                            >
                              <ListItemText primary={isDress ? itemData.dressName : itemData.suitName} secondary={`Código: ${itemData.code}`} />
                            </ListItem>
                          ))}
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  );
                }
                {/* Otros Servicios */ }
                return (
                  <Box key={serviceKey} onClick={() => handleSelectExistingService(serviceKey)} sx={{ p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', backgroundColor: isSelected ? '#e6f2f3' : 'transparent', borderLeft: isSelected ? '5px solid #f759ab' : 'none', borderBottom: '1px solid #eee' }}>
                    <Box sx={{ flex: 3 }}><Typography variant="subtitle2" component="div" fontWeight="bold" noWrap>{service.serviceName}</Typography><Typography variant="caption">{service.quantity} × RD$ {formatCurrency(service.priceWDisc)}{service.discountApplied > 0 && ` (Desc. ${service.discountApplied}%)`}</Typography></Box>
                    <Box textAlign="right" sx={{ flex: 2 }}><Typography variant="subtitle2" fontWeight="bold">RD$ {formatCurrency(service.totalPrice)}</Typography><Typography variant="caption" color={service.paymentStatus === PAYMENT_STATUS_PAID ? 'green' : 'orange'}>(RD$ {formatCurrency(service.amountPaid)} pagados)</Typography></Box>
                    <IconButton size="small" onClick={(e) => { e.stopPropagation(); deleteSelectedService(serviceKey); }} sx={{ ml: 0.5 }}><DeleteOutlineIcon fontSize="small" sx={{ color: 'red' }} /></IconButton>
                  </Box>);
              })}
            </Box>
          </Paper>
          <Paper elevation={2} sx={{ p: 1, mb: 1, textAlign: 'right' }}><Typography variant="h6">Total: RD$ {formatCurrency(calculateGrandTotal)}</Typography></Paper>
          <Paper elevation={2} sx={{ p: 1 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <NumericKeypad onKeyClick={handleKeyClick} onBackspaceClick={handleBackspaceClick} onClearClick={handleClearClick} isQtyActive={editingTarget.type === EDITING_TYPE_SERVICE && editingTarget.field === EDITING_FIELD_QUANTITY} isPriceActive={editingTarget.type === EDITING_TYPE_SERVICE && editingTarget.field === EDITING_FIELD_PRICE} isDiscountActive={editingTarget.type === EDITING_TYPE_SERVICE && editingTarget.field === EDITING_FIELD_DISCOUNT} onActiveChangeQty={() => setActiveEditingTarget(EDITING_TYPE_SERVICE, EDITING_FIELD_QUANTITY)} onActiveChangePrice={() => setActiveEditingTarget(EDITING_TYPE_SERVICE, EDITING_FIELD_PRICE)} onActiveChangeDiscount={() => setActiveEditingTarget(EDITING_TYPE_SERVICE, EDITING_FIELD_DISCOUNT)} disabled={!selectedService && editingTarget.type !== EDITING_TYPE_DEPOSIT} qtyDisabled={selectedService?.serviceType === DRESS_SERVICE_TYPE || selectedService?.serviceType === 'Trajes'} isMobile={true} />
              <Box sx={{ display: 'flex', justifyContent: 'space-around', width: '100%', mt: 1 }}>
                <Tooltip title={isSelectedServicePaid ? 'Marcar como NO pagado' : 'Marcar como pagado (completo)'}><span><IconButton onClick={toggleFullPayment} disabled={!selectedService} size="large">{isSelectedServicePaid ? <AttachMoneyIcon sx={{ color: 'green' }} /> : <MoneyOffIcon sx={{ color: isSelectedServicePartiallyPaid ? 'orange' : 'red' }} />}</IconButton></span></Tooltip>
                <Tooltip title='Editar monto pagado'><span><IconButton onClick={() => setActiveEditingTarget(EDITING_TYPE_SERVICE, EDITING_FIELD_PAID)} disabled={!selectedService} size="large"><img src={editingTarget.type === EDITING_TYPE_SERVICE && editingTarget.field === EDITING_FIELD_PAID ? Bill : BillBlack} alt='Editar pago' style={{ width: '28px', height: '28px' }} /></IconButton></span></Tooltip>
              </Box>
            </Box>
          </Paper>
        </Box>
        <Paper elevation={3} sx={{ position: 'sticky', left: 0, right: 0, p: 1, zIndex: 999, backgroundColor: 'white', pb: 2, pt: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Button variant='contained' onClick={previousStepHandler} startIcon={<ArrowBackIosNewIcon />} sx={{ flexGrow: 1, mr: 0.5, backgroundColor: '#f759ab', '&:hover': { backgroundColor: '#eb2f96' } }}>Regresar</Button>
            <Button variant='contained' onClick={handleProceedToCheckout} sx={{ flexGrow: 1, ml: 0.5, backgroundColor: '#f759ab', '&:hover': { backgroundColor: '#eb2f96' } }}>Proceder</Button>
          </Box>
        </Paper>

        {!isServiceSelectorOpen && (
          <Fab color="secondary" aria-label="Seleccionar Servicios" onClick={openServiceSelector}
            sx={{ position: 'fixed', bottom: 80, left: '85%', transform: 'translateX(-50%)', zIndex: 1000, backgroundColor: '#f759ab', '&:hover': { backgroundColor: '#eb2f96' } }}>
            <ArrowUpwardIcon />
          </Fab>
        )}
        <Paper elevation={4} sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, height: '100dvh', backgroundColor: 'white', zIndex: 9001, display: 'flex', flexDirection: 'column', transform: isServiceSelectorOpen ? 'translateY(0)' : 'translateY(100%)', transition: 'transform 0.3s ease-in-out', overflow: 'hidden', width: '100dvw', maxWidth: '100dvw' }}>
          <Box sx={{ p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'aliceblue', borderBottom: '1px solid #ccc' }}>
            <Typography variant="h6" sx={{ color: '#f759ab' }}>Seleccionar Servicios</Typography>
            <IconButton onClick={closeServiceSelector}><CloseIcon /></IconButton>
          </Box>

          {/* Service Type Filter using MUI Tabs */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%', bgcolor: 'background.paper' }}>
            <Tabs
              value={serviceTypeFilter}
              onChange={handleTabChange}
              variant="scrollable"
              //scrollButtons="auto"
              //allowScrollButtonsMobile
              aria-label="Tipos de servicio"
              sx={{
                '& .MuiTabs-indicator': { backgroundColor: '#f759ab' },
                '& .MuiTab-root': {
                  color: theme.palette.text.secondary,
                  minWidth: 70, // Ajuste para pestañas más pequeñas
                  fontSize: '0.75rem', // Fuente más pequeña para más pestañas
                  padding: '6px 8px', // Menos padding
                  '&.Mui-selected': { color: '#f759ab', fontWeight: 'bold' },
                },
              }}
            >
              {tabOptions.map((type) => (
                <Tab key={type} label={type.length > 10 ? `${type.substring(0, 8)}..` : type} value={type} /> // Acortar etiquetas largas
              ))}
            </Tabs>
          </Box>
          {/* <Divider sx={{ mb: 1 }} /> No es necesario si Tabs ya tiene borderBottom */}

          <Grid container spacing={1} sx={{ flexGrow: 1, overflowY: 'auto', p: 1, alignContent: 'start' }}>
            {(availableServices || [])
              .filter(service => serviceTypeFilter === 'Todos' || service.serviceType === serviceTypeFilter)
              .filter(service => !((service.serviceID === XV_DRESS_SERVICE_ID && selectedAdditionalServices.some(s => s.serviceID === XV_DRESS_SERVICE_ID)) || (service.serviceID === WEDDING_DRESS_SERVICE_ID && selectedAdditionalServices.some(s => s.serviceID === WEDDING_DRESS_SERVICE_ID))))
              .map((service) => (
                <Grid item xs={6} sm={4} key={service.serviceID ?? service.serviceName + '-mobile-card'}> {/* sm={4} para 3 tarjetas en pantallas un poco más grandes */}
                  <ServiceCard
                    service={service}
                    handleSelectedService={handleMobileServiceSelected}
                    isMobile={true}
                  />
                </Grid>
              ))}
            {(availableServices || []).filter(service => serviceTypeFilter === 'Todos' || service.serviceType === serviceTypeFilter).filter(service => !((service.serviceID === XV_DRESS_SERVICE_ID && selectedAdditionalServices.some(s => s.serviceID === XV_DRESS_SERVICE_ID)) || (service.serviceID === WEDDING_DRESS_SERVICE_ID && selectedAdditionalServices.some(s => s.serviceID === WEDDING_DRESS_SERVICE_ID)))).length === 0 && (
              <Grid item xs={12} sx={{ textAlign: 'center', color: '#888', mt: 2 }}>
                <Typography>No hay servicios disponibles para este filtro.</Typography>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Box>
    );
  };

  const DesktopView = () => (
    <div className='services-selection-main-container'>
      <div className='inf-panel-main-container left-side'>
        <div className='selected-services-panel-container top-container' style={{ width: '100%', height: '45vh', backgroundColor: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', overflowY: 'auto', overflowX: 'hidden' }}>
          <div className='selected-services-header' style={{ width: '100%', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'aliceblue', color: '#000' }}>
            <h3 style={{ color: '#f759ab', fontWeight: 'bold' }}>Resumen de servicios</h3>
          </div>
          {/* Servicio Principal (Reserva) */}
          {reservation && Object.keys(reservation).length > 0 && (
            <Tree defaultExpandAll className="reservation-tree" style={{ width: '100%', maxHeight: 'calc(100% - 50px)', margin: 0, padding: 0 }}> {/* Adjusted height */}
              <TreeNode
                key="reservation-root"
                sx={{ width: '100%' }}
                title={
                  <div className='selected-service-container' onClick={() => setActiveEditingTarget(EDITING_TYPE_DEPOSIT)} style={{ backgroundColor: editingTarget.type === EDITING_TYPE_DEPOSIT ? '#e6f7ff' : 'transparent', cursor: 'pointer', width: '100%' }}>
                    <div className='service-left-side-inf' style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'space-evenly', height: '100%' }}>
                      <span style={{ fontWeight: 'bold' }}>{reservation.comboName}</span>
                      <span style={{ fontSize: '14px' }}>1 servicio × RD$ {formatCurrency(reservationComboPrice)}</span>
                      {
                        reservation.discount > 0 && (
                          <span style={{ fontSize: '14px', color: 'green' }}>Descuento del {reservation.discount}% aplicado</span>
                        )
                      }
                    </div>
                    <div className='service-right-side-inf' style={{ display: 'flex', width: '100%', height: '100%', minHeight: '45px', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center' }}>
                      <span style={{ fontWeight: 'bold' }}>RD$ {formatCurrency(reservationComboPrice * ((100 - reservation.discount) / 100))}</span>
                      <span style={{ fontSize: '0.8rem' }}>(RD$ {formatCurrency(deposit)} pagados)</span>
                    </div>
                    <div className='action-btn-container' style={{ marginRight: 0, marginLeft: '8px' }}>
                      <Tooltip title='Editar depósito pagado'>
                        <IconButton size="small" >
                          <EditIcon sx={{ fontSize: 22, color: editingTarget.type === EDITING_TYPE_DEPOSIT ? "#1890ff" : "#52c41a" }} />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                }
              >
                {
                  reservation.shortDress && (
                    <TreeNode key="reservation-short" title={<div style={{ fontSize: '12px' }}><span style={{ fontWeight: 'bold' }}>Vestido corto:</span> {reservation.shortDress || 'N/A'}</div>} isLeaf />
                  )
                }
                {
                  reservation.longDress && (
                    <TreeNode key="reservation-long" title={<div style={{ fontSize: '12px' }}><span style={{ fontWeight: 'bold' }}>Vestido largo:</span> {reservation.longDress || 'N/A'}</div>} isLeaf />
                  )
                }
                {
                  reservation.suit && (
                    <TreeNode key="reservation-suit" title={<div style={{ fontSize: '12px' }}><span style={{ fontWeight: 'bold' }}>Traje del novio:</span> {reservation.suit || 'N/A'}</div>} isLeaf />
                  )
                }
              </TreeNode>
            </Tree>
          )}
          {/* Otros Servicios */}
          {selectedAdditionalServices?.map((service) => {
            const serviceKey = service.serviceID ?? service.serviceName;
            const isSelected = selectedServiceKey === serviceKey;

            if (service.serviceType === DRESS_SERVICE_TYPE || service.serviceType === SUIT_SERVICE_TYPE || service.serviceType === CHILD_SUIT_TYPE) {
              const isDress = service.serviceType === DRESS_SERVICE_TYPE;
              const items = isDress ? service.dresses : service.suits;
              const itemType = isDress ? (service.quantity > 1 ? 'vestidos' : 'vestido') : (service.quantity > 1 ? 'trajes' : 'traje');
              const handleEdit = isDress ? handleEditDress : handleEditSuit;
              const handleDelete = isDress ? handleDeleteDress : handleDeleteSuit;

              return (
                <Accordion key={serviceKey} sx={{ boxShadow: isSelected ? '0 0 0 2px #f759ab' : 'none', border: '1px solid #eee', mb: 1, '&:before': { display: 'none' }, width: '96%' }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    // Quitamos cualquier onClick de aquí para permitir el comportamiento nativo de expansión
                    sx={{ '& .MuiAccordionSummary-content': { justifyContent: 'space-between', alignItems: 'center' } }}
                  >
                    {/* ESTE DIV se encarga de la selección y ocupa todo el espacio disponible */}
                    <div
                      style={{ display: 'flex', flexGrow: 1, alignItems: 'center' }}
                      onClick={() => handleSelectExistingService(serviceKey)}
                    >
                      <div className='service-left-side-inf'>
                        <span style={{ fontWeight: 'bold' }}>{service.serviceName}</span>
                        <br />
                        <span>{service.quantity} {service.quantity > 1 ? 'vestidos' : 'vestido'}</span>
                        <br />
                        {service.discountApplied > 0 ? (
                          <div style={{ fontSize: '13px' }}>
                            <span>{service.quantity} × RD$ {formatCurrency(service.priceWDisc)}</span><br />
                            <span style={{ fontStyle: 'italic', color: '#888' }}>(con {service.discountApplied}% desc.)</span>
                          </div>
                        ) : (<span style={{ fontSize: '13px' }}>{service.quantity} × RD$ {formatCurrency(service.servicePrice)}</span>)}
                      </div>
                      <div className='service-right-side-inf' style={{ textAlign: 'right' }}>
                        <span style={{ fontWeight: 'bold' }}>RD$ {formatCurrency(service.totalPrice)}</span>
                        <div><span style={{ fontSize: '13px', color: service.paymentStatus === 'pagado' ? 'green' : 'orange' }}>(RD$ {formatCurrency(service.amountPaid)} pagados)</span></div>
                      </div>
                    </div>

                    {/* El botón de borrado está fuera del div de selección */}
                    <div className='action-btn-container'>
                      {/* Solución al aviso: envolver el IconButton en un span */}
                      <Tooltip title='Quitar servicio'>
                        <span>
                          <IconButton size="small" onClick={(e) => { e.stopPropagation(); deleteSelectedService(serviceKey); }}>
                            <DeleteOutlineIcon sx={{ fontSize: 22, color: 'red' }} />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0, backgroundColor: '#fafafa' }}>
                    <List dense disablePadding>
                      {items.map(itemData => (
                        <ListItem
                          key={isDress ? itemData.dressID : itemData.suitID}
                          divider
                          secondaryAction={
                            <>
                              <Tooltip title={isDress ? "Cambiar vestido" : "Cambiar traje"}>
                                <span>
                                  <IconButton size="small" sx={{ mr: 0.5 }} onClick={(e) => { e.stopPropagation(); handleEdit(service, itemData); }}>
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <Tooltip title={isDress ? "Quitar vestido" : "Quitar traje"}>
                                <span>
                                  <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleDelete(service, itemData); }}>
                                    <DeleteOutlineIcon fontSize="small" color="error" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </>
                          }
                        >
                          <ListItemText primary={isDress ? itemData.dressName : itemData.suitName} secondary={`Código: ${itemData.code}`} />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
              );
            }

            return (
              <Paper
                key={serviceKey}
                onClick={() => handleSelectExistingService(serviceKey)}
                elevation={0}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: '8px 8px',
                  mb: 0.5,
                  border: '1px solid #eee',
                  cursor: 'pointer',
                  boxShadow: isSelected ? '0 0 0 2px #f759ab' : 'none',
                  width: '94%',
                }}
              >
                <div className='service-left-side-inf' style={{ display: 'flex', flexDirection: 'column', width: 'auto', justifyContent: 'center' }}>
                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{service.serviceName}</span>
                  {service.discountApplied > 0 ? (
                    <div style={{ fontSize: '13px' }}>
                      <span>{service.quantity} × RD$ {formatCurrency(service.priceWDisc)}</span><br />
                      <span style={{ fontStyle: 'italic', color: '#888' }}>(con {service.discountApplied}% desc.)</span>
                    </div>
                  ) : (<span style={{ fontSize: '13px' }}>{service.quantity} × RD$ {formatCurrency(service.servicePrice)}</span>)}
                </div>
                <div className='service-right-side-inf' style={{ textAlign: 'right' }}>
                  <span style={{ fontWeight: 'bold' }}>RD$ {formatCurrency(service.totalPrice)}</span>
                  <div><span style={{ fontSize: '13px', color: service.paymentStatus === 'pagado' ? 'green' : 'orange' }}>(RD$ {formatCurrency(service.amountPaid)} pagados)</span></div>
                </div>
                <div className='action-btn-container'>
                  <Tooltip title='Quitar servicio'><IconButton size="small" onClick={(e) => { e.stopPropagation(); deleteSelectedService(serviceKey); }}><DeleteOutlineIcon sx={{ fontSize: 22, color: 'red' }} /></IconButton></Tooltip>
                </div>
              </Paper>
            );
          })}
        </div>
        <Divider orientation='horizontal' flexItem />
        <div className="total-summary-container" style={{ width: '100%', height: '7vh', backgroundColor: '#fff', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', overflowY: 'hidden', overflowX: 'hidden' }}>
          <h3 style={{ fontSize: '20px', color: 'green', margin: 0, marginRight: '30px' }}>Total: RD$ {formatCurrency(calculateGrandTotal)}</h3>
        </div>
        <Divider orientation='horizontal' flexItem />
        <div className='bottom-container' style={{ width: '100%', height: '47vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div className='quantity-control-container' style={{ width: '96%', height: '75%', minWidth: '360px', marginTop: '10px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around' }}>
            <NumericKeypad onKeyClick={handleKeyClick} onBackspaceClick={handleBackspaceClick} onClearClick={handleClearClick} isQtyActive={editingTarget.type === EDITING_TYPE_SERVICE && editingTarget.field === EDITING_FIELD_QUANTITY} isPriceActive={editingTarget.type === EDITING_TYPE_SERVICE && editingTarget.field === EDITING_FIELD_PRICE} isDiscountActive={editingTarget.type === EDITING_TYPE_SERVICE && editingTarget.field === EDITING_FIELD_DISCOUNT} onActiveChangeQty={() => setActiveEditingTarget(EDITING_TYPE_SERVICE, EDITING_FIELD_QUANTITY)} onActiveChangePrice={() => setActiveEditingTarget(EDITING_TYPE_SERVICE, EDITING_FIELD_PRICE)} onActiveChangeDiscount={() => setActiveEditingTarget(EDITING_TYPE_SERVICE, EDITING_FIELD_DISCOUNT)} disabled={!selectedService && editingTarget.type !== EDITING_TYPE_DEPOSIT} qtyDisabled={selectedService?.serviceType === DRESS_SERVICE_TYPE || selectedService?.serviceType === 'Trajes'} />
            <div className="keypad-action-buttons" style={{ width: '22%', display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%' }}>
              <Tooltip title={isSelectedServicePaid ? 'Marcar como NO pagado' : 'Marcar como pagado (completo)'} placement='top'><span style={{ height: '50%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}><IconButton onClick={toggleFullPayment} disabled={!selectedService}>{isSelectedServicePaid ? <AttachMoneyIcon style={{ fontSize: 35, color: 'green', width: '40px', height: '40px' }} /> : <MoneyOffIcon style={{ fontSize: 35, color: isSelectedServicePartiallyPaid ? 'orange' : 'red', width: '40px', height: '40px' }} />}</IconButton></span></Tooltip>
              <Tooltip title='Editar monto pagado' placement='top'><span style={{ height: '50%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}><IconButton onClick={() => setActiveEditingTarget(EDITING_TYPE_SERVICE, EDITING_FIELD_PAID)} disabled={!selectedService}><img src={editingTarget.type === EDITING_TYPE_SERVICE && editingTarget.field === EDITING_FIELD_PAID ? Bill : BillBlack} alt='Editar pago' style={{ width: '35px', height: '35px' }} /></IconButton></span></Tooltip>
            </div>
          </div>
          <div className='go-to-pay-panel-container' style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-around', height: '25%' }}>
            <div className='step-btn-container' style={{ display: 'flex', justifyContent: 'space-between', width: '90%', height: '100%', alignItems: 'center' }}>
              <Button variant='contained' onClick={previousStepHandler} startIcon={<ArrowBackIosNewIcon />} sx={{ backgroundColor: '#f759ab', color: '#fff', '&:hover': { backgroundColor: '#eb2f96' }, padding: '10px 20px', fontSize: '16px', borderRadius: '8px' }}>Regresar</Button>
              <Button variant='contained' onClick={handleProceedToCheckout} sx={{ backgroundColor: '#f759ab', color: '#fff', '&:hover': { backgroundColor: '#eb2f96' }, padding: '10px 20px', fontSize: '16px', borderRadius: '8px' }}>Proceder al pago</Button>
            </div>
          </div>
        </div>
      </div>
      <Divider orientation="vertical" flexItem />
      <div className='services-offered-main-container right-side'>
        <Slider {...desktopSliderSettings} className="service-type-slider" style={{ width: '92%', marginLeft: '35px', marginBottom: '25px' }}>
          <div key="todos-filter" onClick={() => handleServiceTypeFilterChange('Todos')}>
            <span className={`services-type ${serviceTypeFilter === 'Todos' ? ' service-type-selected' : ' service-no-selected'}`}>
              <strong>Todos</strong>
            </span>
          </div>
          {(arrOfServiceTypes || []).filter(type => type !== 'Inventario' && type !== 'Eventos').map((type) => (<div key={type} onClick={() => handleServiceTypeFilterChange(type)}><span className={`services-type ${serviceTypeFilter === type ? ' service-type-selected' : ' service-no-selected'}`}><strong>{type}</strong></span></div>))}
        </Slider>
        <Divider flexItem sx={{ mb: 2 }} />
        <div className='services-offers-container'>
          {
            availableServices
              ?.filter(service => serviceTypeFilter === 'Todos' || service.serviceType === serviceTypeFilter)
              ?.filter(service => service.serviceType !== 'Inventario' && service.serviceType !== 'Eventos')
              ?.map((service) => (
                <ServiceCard key={service.serviceID ?? service.serviceName} service={service} handleSelectedService={handleSelectServiceToAdd} />
              ))
          }
          {(availableServices || []).filter(service => serviceTypeFilter === 'Todos' || service.serviceType === serviceTypeFilter).length === 0 && (<p style={{ textAlign: 'center', color: '#888', marginTop: '20px' }}>No hay servicios disponibles para este filtro.</p>)}
        </div>
      </div>
    </div>
  );

  return (
    <div className={`${isMobile ? 'mobile-view' : ''}`} style={{ height: 'calc(100vh - 84px)' }}>
      {isMobile ? <MobileView /> : <DesktopView />}
      <RentDressDialog open={openXVDressDialog}
        onClose={() => setOpenXVDressDialog(false)}
        onSelect={handleSelectedXVDress} dressList={XVDressList}
        dressSelectionService={dressSelectionServiceInfo}
        newDressReservation={newDressReservation}
      />
      <RentDressDialog open={openWDressDialog}
        onClose={() => setOpenWDressDialog(false)}
        onSelect={handleSelectedWDress} dressList={WDressList}
        dressSelectionService={dressSelectionServiceInfo}
        newDressReservation={newDressReservation}
      />
      <RentDressDialog open={openPersonalDressDialog}
        onClose={() => setOpenPersonalDressDialog(false)}
        onSelect={handleSelectedPersonalDress} dressList={personalDressList}
        dressSelectionService={dressSelectionServiceInfo}
        newDressReservation={newDressReservation}
      />
      <RentDressDialog open={openChildDressDialog}
        onClose={() => setOpenChildDressDialog(false)}
        onSelect={handleSelectedChildDress} dressList={childDressList}
        dressSelectionService={dressSelectionServiceInfo}
        newDressReservation={newDressReservation}
      />
      <RentSuitDialog open={openSuitDialog}
        onClose={() => setOpenSuitDialog(false)}
        onSelect={handleSelectedSuit} suitList={menSuitList}
        suitSelectionService={suitSelectionServiceInfo}
        newSuitReservation={newSuitReservation}
        suitReservations={suitReservations}
        dateRange={{ eventDateStart: event.eventDateStart, eventDateEnd: event.eventDateEnd }}
      />
      <RentSuitDialog open={openChildSuitDialog}
        onClose={() => setOpenChildSuitDialog(false)}
        onSelect={handleSelectedChildSuit} suitList={childSuitList}
        suitSelectionService={suitSelectionServiceInfo}
        newSuitReservation={newSuitReservation}
        suitReservations={suitReservations}
        dateRange={{ eventDateStart: event.eventDateStart, eventDateEnd: event.eventDateEnd }}
      />
    </div>
  );
};

export default AdditionalServicesRe;